/**
 * Helper function to generate base URL with locale only for English
 * @param path - Optional path to append to the base URL
 * @param locale - Current locale
 * @returns Formatted URL with locale only for English
 */
import { getEnv } from '@/lib/config/runtime-env'

export const getBaseUrl = (path: string = '', locale: string = '') => {
  const baseUrl = getEnv().MOTOR_BASE_URL
  // Only include locale for English, not for Arabic
  const localePath = locale ? `/${locale}` : '/ar'
  return `${baseUrl}${localePath}${path}`
}
